export default __webpack_public_path__ + "static/media/interno_5.a874e37c.jpg";